import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { endpoints, fetcher } from 'services';
import { INIT_PAGESIZE } from 'commons/constants';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';

const useMyOperator = (page: string, userid: string) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [operatorList, setOperatorList] = useState<MyOperatorItemDto[]>();
  const [searchResult, setSearchResult] = useState({ pageNo: 0, pageSize: INIT_PAGESIZE, totalCount: 0 });

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();
  const searchParams = qs.parse(location.search);
  const { isLoading, refetch } = useQuery(
    [endpoints.mypage.op1, [location.search, userid, page]],
    () =>
      fetcher.mypage.postOperatorList1({
        pageNo: Number(searchParams.pageNo) || 1,
        pageSize: Number(searchParams.pageSize) || INIT_PAGESIZE,
        op: String(userid),  
        group: String(page),  
      }),
    {
      enabled: (page === 'op1' || page === 'op2'), 
      onSuccess: (res: CommonSearchListResDto) => {
        switch (res.code) {
          case 200:
            setOperatorList(res.result?.list);
            setSearchResult({
              pageNo: res.result?.pageNo || 1,
              pageSize: res.result?.pageSize || INIT_PAGESIZE,
              totalCount: res.result?.totalCount || 0,
            });
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  return { operatorList, searchResult, refetch };
};

export default useMyOperator;
